import { useSwrNoAuth } from "../swr/useSwrNoAuth";

type SelectedQuestions = {
  id: string;
  question: string;
  question_content: string;
}[]

export const useFetchKuchikomyuSurveyEnSelectedQuestionsCustomer = (restaurantId: string) => {
  const { data: selectedQuestions, isLoading } = useSwrNoAuth<SelectedQuestions>(`kuchikomyu/restaurants/${restaurantId}/survey/en-selected-questions/customer/`)
  return { selectedQuestions, isLoading };
};